import { PriceCellProps } from "./ProductsTable.types";

import styles from "./ProductsTable.module.scss";

export const PriceCell = ({ price, discountedPrice }: PriceCellProps) => (
  <>
    <div className={styles.productTable_accentText}>{discountedPrice} FCFA</div>

    {price !== discountedPrice ? (
      <div className={styles.productTable_oldPrice}>{price} FCFA</div>
    ) : null}
  </>
);
